import type { IResidentialComplex } from 'shared/types/residentials';

export function getResidentialComplexImageUrl({ displayType, fullImgUrl, imgUrl }: IResidentialComplex): string {
  let imageUrl;

  if (displayType === 'plus') {
    imageUrl = fullImgUrl || imgUrl;
  } else {
    imageUrl = imgUrl || fullImgUrl;
  }

  return imageUrl || '';
}
